export type MyGreenhouseFilters = {
  page: number;
  perPage: number;
  savedForLater: 'saved' | 'not_saved' | null;
  minExperience: string | null;
  maxExperience: string | null;
  companyNameFilters: Array<{ id: string; mode: string; value: string }>;
  educationFilters: unknown[];
  workPreferenceLanguages: unknown[];
  workPreferenceEmploymentTypes: unknown[];
  workPreferenceWorksites: unknown[];
  workPreferenceLocations: unknown[];
  workPreferenceWillingToRelocate: boolean;
  canHave: string[];
  mustHave: string[];
  doesNotHave: string[];
};

export const MY_GREENHOUSE_DEFAULT_VALUES: MyGreenhouseFilters = {
  page: 1,
  perPage: 50,
  savedForLater: null,
  minExperience: null,
  maxExperience: null,
  companyNameFilters: [],
  educationFilters: [],
  workPreferenceLanguages: [],
  workPreferenceEmploymentTypes: [],
  workPreferenceWorksites: [],
  workPreferenceLocations: [],
  workPreferenceWillingToRelocate: false,
  canHave: [],
  mustHave: [],
  doesNotHave: [],
};
